<button type="button" (click)="onPaymentClick()" [class.active]="title === currentPayment"
  [class.notActive]="title !== currentPayment" class="payment">
  <header class="paymentTitle">{{ title | translate }}</header>
  <img [src]="image" [alt]="'Common.Payment.select' | translate" class="paymentImage">
</button>